"use client";

import { useGetPostsQuery } from "@/store/features/postApiSlice";
import { useMemo } from "react";

const usePosts = () => {
  const { data = [], isLoading } = useGetPostsQuery();

  const posts = useMemo(() => {
    return data.map((item) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(item.content, "text/html");
      const textContent = doc.body.textContent || "";
      const words = textContent.trim().split(/\s+/);
      const modifiedContent =
        words.slice(0, 30).join(" ") + (words.length > 30 ? "..." : "");

      return {
        ...item,
        content: modifiedContent,
      };
    });
  }, [data]);

  return { loading: isLoading, posts };
};

export default usePosts;
